import type { ReactNode } from 'react'

export const WorkspacePanes = ({
  list,
  listLabel,
  main,
  aside,
  asideLabel,
}: {
  list?: ReactNode
  listLabel?: string
  main: ReactNode
  aside?: ReactNode
  asideLabel?: string
}) => (
  <div className="panes">
    {list === undefined ? null : (
      <section className="pane pane-list" {...(listLabel === undefined ? {} : { 'aria-label': listLabel })}>
        {list}
      </section>
    )}
    <section className="pane pane-main">{main}</section>
    {aside === undefined ? null : (
      <aside className="pane pane-aside" {...(asideLabel === undefined ? {} : { 'aria-label': asideLabel })}>
        {aside}
      </aside>
    )}
  </div>
)
